// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accumulation-body__header{color:var(--text-color);font-size:18px;margin-top:20px;position:relative}.accumulation-body__header .amount-box{color:var(--amount-color)}.accumulation-body__header.is-mobile{font-size:14px;margin-top:10px;padding:0 11px}.accumulation-body__header.is-mobile .time{margin-right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
